// PrivacyPolicy.js
import React from 'react';
import { Card } from 'antd'; // Using Ant Design for styling

const PrivacyPolicy = () => {
  return (
    <Card title="Privacy Policy" style={{ margin: '20px' }}>
      <p>
        Your privacy is important to us. It is HRM360's policy to respect your privacy regarding any information we may collect from you across our website, hrm360.softomation.com, and other sites we own and operate.
      </p>
      <h2>1. Information we collect</h2>
      <p>
        We only collect information about you if we have a reason to do so — for example, to provide our Services, to communicate with you, or to make our Services better.
      </p>
      <h3>1.1 Location Data</h3>
      <p>
        HRM360 captures your location to mark attendance. We collect location data only when the app is in use to ensure accurate attendance tracking. Your location data is not shared with third parties and is used solely for attendance purposes.
      </p>
      <h3>1.2 Device Information</h3>
      <p>
        To provide a better experience, we require the Android permission `READ_PHONE_STATE` to access information about your device. This permission allows us to gather information about your device's state to ensure the app functions correctly.
      </p>
      <h2>2. How we use information</h2>
      <p>
        We use information about you as mentioned above and for the purposes listed below:
        <ul>
          <li>To provide our services</li>
          <li>To further develop and improve our services</li>
          <li>To monitor and analyze trends and better understand how users interact with our services</li>
          <li>To monitor and protect the security of our information, systems, and network</li>
        </ul>
      </p>
      <h2>3. Information sharing</h2>
      <p>
        We do not share any personally identifying information publicly or with third-parties, except when required to by law.
      </p>
      <h2>4. Your privacy rights</h2>
      <p>
        You have the right to request access to the personal data we have collected about you. You also have the right to request the correction, amendment, or deletion of your personal data.
      </p>
      <h2>5. Changes to this privacy policy</h2>
      <p>
        We may change our Privacy Policy from time to time. We encourage visitors to frequently check this page for any changes to our Privacy Policy.
      </p>
      <p>
        If you have any questions about this Privacy Policy, please contact us.
      </p>
    </Card>
  );
};

export default PrivacyPolicy;
